import { Fragment, memo } from 'react';
import { Flex, Text } from '@qga/roo-ui/components';
import { QFF_SIGNUP_URL } from '../../../../../lib/config';
import { formatNumber, formatName } from '../../../../../lib/formatters';
import {
  MembershipTier,
  StyledText,
  JoinLink,
  HoveredText,
} from './primitives';
import { useHeaderContext } from '../../../HeaderContext';
import { QffAuthData } from '../../../types';
import type { FC } from 'react';

export const QffAuthDetails: FC = () => {
  const { qffAuthData } = useHeaderContext();

  return <QffAuthDetailsMemo {...qffAuthData} />;
};

const QffAuthDetailsMemo = memo(
  ({
    isAuthenticated,
    title,
    firstName,
    lastName,
    membershipTier,
    pointsBalance,
    memberId,
  }: QffAuthData) => (
    <Fragment>
      {isAuthenticated && (
        <Flex flexDirection="column" color="white" justifyContent="flex-start">
          <StyledText data-hj-suppress data-testid="member-name-id">
            {formatName({
              title: title!,
              firstName: firstName!,
              lastName: lastName!,
            })}{' '}
            ({memberId})
          </StyledText>
          <Flex flexWrap="wrap">
            <MembershipTier data-testid="member-tier">
              {membershipTier} Frequent Flyer
            </MembershipTier>
            <StyledText mx={1}>-</StyledText>
            <StyledText data-testid="member-points-balance">
              {formatNumber(pointsBalance!)} points
            </StyledText>
          </Flex>
        </Flex>
      )}
      {!isAuthenticated && (
        <Flex textAlign="left" pr={4} data-testid="not-auth-wrapper">
          <JoinLink
            href={`${QFF_SIGNUP_URL}?thirdParty=hooroos`}
            data-testid="sign-up-link"
          >
            <Text>Not a member? </Text>
            <HoveredText>Join now</HoveredText>
          </JoinLink>
        </Flex>
      )}
    </Fragment>
  )
);

QffAuthDetailsMemo.displayName = 'QffAuthDetailsMemo';
